import(/* webpackMode: "eager", webpackExports: ["PrivacyView"] */ "/web/src/sections/policy/privacy/view/privacy-view.tsx");
